import { getDashboardData } from 'modules/society/actions/dashBoardActions';

export const getOperationsViewData = async (societyId, dispatch) => {
  const operationsData = await dispatch(
    getDashboardData(societyId, 'operations')
  );
  return operationsData;
};
